const toExercise = (exercise) => {
  let html = `<p class="single-exercise__main">${exercise.name}</p>`;

  if (exercise.description) {
    html += `<small class="single-exercise__description">${exercise.description}</small>`;
  }

  return `<div class="single-exercise">${html}</div>`;
};

const toBoxingCombo = (moves) => {
  const movesList = moves.map(move => {
    return `
      <div class="combo__move-wrapper">
        <div class="combo__move combo__move--active combo__move--${move.replace(' ', '-')}">${move}</div>
        <div class="combo__move combo__move--empty"></div>
      </div>
    `
  }).join('');

  return `<div class="combo__moves">${movesList}</div>`;
}

export { toExercise, toBoxingCombo };
